/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_fr_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2/3 × 3/4 = 1/2 after simplifying.`)
};

const es_fr_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2/3 × 3/4 = 1/2 tras simplificar.`)
};

const de_fr_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2/3 × 3/4 = 1/2 nach dem Kürzen.`)
};

const nl_fr_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2/3 × 3/4 = 1/2 na vereenvoudiging.`)
};

const fr_fr_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2/3 × 3/4 = 1/2 après simplification.`)
};

const it_fr_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2/3 × 3/4 = 1/2 dopo la semplificazione.`)
};

const pt_br2_fr_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2/3 × 3/4 = 1/2 depois de simplificar.`)
};

const pt_fr_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2/3 × 3/4 = 1/2 depois de simplificar.`)
};

const ja_fr_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2/3 × 3/4 = 1/2 (簡約後)。`)
};

const zh_fr_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2/3 × 3/4 化简后为 1/2。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const fr_ex2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.fr_ex2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("fr_ex2", locale)
	if (locale === "en") return en_fr_ex2(inputs)
	if (locale === "es") return es_fr_ex2(inputs)
	if (locale === "de") return de_fr_ex2(inputs)
	if (locale === "nl") return nl_fr_ex2(inputs)
	if (locale === "fr") return fr_fr_ex2(inputs)
	if (locale === "it") return it_fr_ex2(inputs)
	if (locale === "pt-BR") return pt_br2_fr_ex2(inputs)
	if (locale === "pt") return pt_fr_ex2(inputs)
	if (locale === "ja") return ja_fr_ex2(inputs)
	return zh_fr_ex2(inputs)
};